export const SET_PAYMENT_CARD_STORE = "SET_PAYMENT_CARD_GO_BACK";
export const SET_PAYMENT_CARD_RESET = "SET_PAYMENT_CARD_RESET";

// Nhập liệu
export const FETCH_PAYMENT_CARD_CREATE_REQUEST = "FETCH_PAYMENT_CARD_CREATE_REQUEST";
export const FETCH_PAYMENT_CARD_CREATE_SUCCESS = "FETCH_PAYMENT_CARD_CREATE_SUCCESS";
export const FETCH_PAYMENT_CARD_CREATE_FAILURE = "FETCH_PAYMENT_CARD_CREATE_FAILURE";

// Xác nhận
export const FETCH_PAYMENT_CARD_CONFIRM_REQUEST = "FETCH_PAYMENT_CARD_CONFIRM_REQUEST";
export const FETCH_PAYMENT_CARD_CONFIRM_SUCCESS = "FETCH_PAYMENT_CARD_CONFIRM_SUCCESS";
export const FETCH_PAYMENT_CARD_CONFIRM_FAILURE = "FETCH_PAYMENT_CARD_CONFIRM_FAILURE";

// Xác thực
export const FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST = "FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST";
export const FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_SUCCESS = "FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_FAILURE = "FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_FAILURE";
